const actionTypes = {
  GET_SETTINGS: 'userSettings/GET_SETTINGS',
};

const getSettings = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const response = await api.finance.getSettings();
  if (response.success) {
    dispatch({
      type: actionTypes.GET_SETTINGS,
      payload: response.data,
    });
  }
};

export { actionTypes, getSettings };
